export class Upload {
  constructor(readonly key: string,
              readonly file: File,
              readonly name: string,
              readonly url: string,
              readonly progress: number,
              readonly createdAt: Date = new Date()) {
  }
}
